import { FileFormats } from "../../../../components/finalForms/libs/data/fileFormatTypes";
import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes";

const initState = {
    profilePic: null,
    firstName: "",
    lastName: "",
    userName: "",
    phone: "",
    emailAddress: "",
    gender: "",
    addressLineId: "",
    organizationId: "",
};

export const multiRowFormConfig = {
    name: "User Form",
    initialState: initState,
    section: [
        {
            sectionId: 'basicDetailSection',
            title: "Profile Section",
            row: {},
            style: {
                sectionStyle: "col-lg-6 col-md-6 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
            fields: [
                {
                    id: "profilePic",
                    Field_Name: "profile photo",
                    fieldType: FormFieldTypes.FILE,
                    dataField: "profilePic",
                    fieldSetting: {
                        placeholder: "Upload Data File",
                        allowMultipleFiles: false,
                        acceptedFileFormats: [
                            FileFormats.PDF,
                            FileFormats.DOC,
                            FileFormats.DOCX,
                            FileFormats.XLSX,
                        ],
                        minFileSizeInMB: 0, // Minimum File size in MB
                        maxFileSizeInMB: 8, // Maximum File size in MB
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 profile-pic-upload .validation-text-fileuploader",
                    },
                },
            ],
        },
        {
            title: "User Information",
            row: {},
            style: {
                sectionStyle: "col-lg-6 col-md-6 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
            fields: [
                {
                    id: "userName",
                    label: "User Name",
                    Field_Name: "user name",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "userName",
                    fieldSetting: {
                        placeholder: "Please Enter User Name",
                        allowSpace: true,
                        isDisable: false,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0",
                    },
                },
                {
                    id: "emailAddress",
                    label: "Email Address",
                    Field_Name: "email",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "emailAddress",
                    fieldSetting: {
                        placeholder: "Please Enter Email Address",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0",
                    },
                },
                {
                    id: "phone",
                    label: "Contact Number",
                    Field_Name: "phone number",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "phone",
                    fieldSetting: {
                        placeholder: "Please Enter Phone Number",
                        maskFormat: true,
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0",
                    },
                },
            ]
        },
        {
            title: "User Information 2",
            row: {},
            style: {
                sectionStyle: "col-lg-4 col-md-4 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
            fields: [
                {
                    id: "userName",
                    label: "User Name",
                    Field_Name: "user Nname",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "userName",
                    fieldSetting: {
                        placeholder: "Please Enter User Name",
                        allowSpace: true,
                        isDisable: false,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0",
                    },
                },
                {
                    id: "emailAddress",
                    label: "Email Address",
                    Field_Name: "email",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "emailAddress",
                    fieldSetting: {
                        placeholder: "Please Enter Email Address",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0",
                    },
                },
                {
                    id: "phone",
                    label: "Contact Number",
                    Field_Name: "phone number",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "phone",
                    fieldSetting: {
                        placeholder: "Please Enter Phone Number",
                        maskFormat: true,
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0",
                    },
                },
            ]
        },
        {
            title: "User Information 3",
            row: {},
            style: {
                sectionStyle: "col-lg-4 col-md-4 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
            fields: [
                {
                    id: "firstName",
                    label: "First Name",
                    Field_Name: "first name",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "firstName",
                    fieldSetting: {
                        placeholder: "Please Enter First Name",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0",
                    },
                },
                {
                    id: "lastName",
                    label: "Last Name",
                    Field_Name: "last name",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "lastName",
                    fieldSetting: {
                        placeholder: "Please Enter Last Name",
                        allowSpace: true,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-6 col-md-6 validation-left-0",
                    },
                },
                {
                    id: "gender",
                    label: "Gender",
                    Field_Name: "gender",
                    fieldType: FormFieldTypes.RADIOBUTTON,
                    dataField: "gender",
                    fieldSetting: {
                        allowSpace: true,
                        options: [
                            { value: "Male", label: "Male" },
                            { value: "Female", label: "Female" },
                        ],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 radioStyle col-md-6 validation-left-0",
                    },
                },
            ],
        },
        {
            title: "User Information Section",
            row: {},
            style: {
                sectionStyle: "col-lg-4 col-md-4",
            },
            wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
            rowGroup: [
                {
                    groupLabel: "Personal Information", // Group for personal details
                    style: {
                        groupStyle: "col-lg-12 col-md-12 mb-2",
                    },
                    groupWrapper: <div className="form-card row"></div>,
                    fields: [
                        {
                            id: "gender",
                            label: "Gender : ",
                            Field_Name: "gender",
                            fieldType: FormFieldTypes.RADIOBUTTON,
                            dataField: "gender",
                            fieldSetting: {
                                allowSpace: true,
                                options: [
                                    { value: "Male", label: "Male" },
                                    { value: "Female", label: "Female" },
                                ],
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: {
                                containerCss: "col-lg-12 radioStyle col-md-6 validation-left-0",
                            },
                        },
                    ],
                },
                {
                    groupLabel: "Personal Information", // Group for personal details
                    style: {
                        groupStyle: "col-lg-12 col-md-12 mb-2",
                    },
                    groupWrapper: <div className="form-card row"></div>,
                    fields: [
                        {
                            id: "test",
                            label: "",
                            Field_Name: "test",
                            fieldType: FormFieldTypes.CHECKBOX,
                            dataField: "test",
                            fieldSetting: {
                                allowSpace: true,
                                subTitle: "Test"
                            },
                            style: {
                                containerCss: "col-lg-4 col-md-4 double-label-sec",
                            },
                        },
                    ],
                },
            ],
        },
        {
            title: "Skills Section",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-2 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
            fields: [
                {
                    id: "singleSkill",
                    label: "Skill",
                    Field_Name: "skill",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "singleSkill",
                    fieldSetting: {
                        placeholder: "Please Select a Skill",
                        allowSpace: true,
                        options: [
                            { label: "City 1", value: 1 },
                            { label: "City 2", value: 2 },
                            { label: "City 3", value: 3 },
                        ],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 col-md-4 validation-left-0",
                    },
                },
                {
                    id: "skills",
                    label: "Skills : ",
                    Field_Name: "skills",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "skills",
                    fieldSetting: {
                        placeholder: "Please Select Skills",
                        isMultiSelect: true,
                        allowSpace: true,
                        options: [
                            { label: "React", value: 1 },
                            { label: "Node", value: 2 },
                            { label: "Java", value: 3 },
                            { label: "Python", value: 4 },
                        ],
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-4 col-md-4 validation-left-0",
                    },
                },
                {
                    id: "editableDropdown",
                    label: "Editable Dropdown",
                    Field_Name: "editable dropdown",
                    fieldType: FormFieldTypes.EDITABLEDROPDOWN,
                    dataField: "editableDropdown",
                    fieldSetting: {
                        placeholder: "Please Select Data",
                        options: [
                            { label: "Option 1", value: 1 },
                            { label: "Option 2", value: 2 },
                            { label: "Option 3", value: 3 },
                        ],
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-lg-4 col-md-4 validation-left-0",
                    },
                },
            ],
        },
        {
            title: "Notes Section",
            row: {},
            style: {
                sectionStyle: "col-lg-12 col-md-2 mb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>, // Wrapper HTML or Component
            fields: [
                {
                    id: "notes",
                    label: "Notes",
                    Field_Name: "notes",
                    fieldType: FormFieldTypes.TEXTAREA,
                    dataField: "notes",
                    fieldSetting: {
                        placeholder: "Please Enter Notes",
                        showCharacterLength: false,
                        isDisable: false,
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0",
                    },
                },
                {
                    id: "userComment",
                    label: "User Comment",
                    Field_Name: "user comment",
                    fieldType: FormFieldTypes.TEXTEDITOR,
                    dataField: "userComment",
                    fieldSetting: {
                        placeholder: "Please Enter User Comment",
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-12 mb-2",
                    },
                },
            ],
        },
    ]

}